export default __webpack_public_path__ + "static/media/logo.4d995085.png";